// src/pages/Moderation/ModerationQueuePage/ui/ReportsTable/ReportsTable.tsx
import React from 'react';
import './ReportsTable.scss';

import { Loader } from 'components/Loader';
import { Pagination } from 'ui/NewPagination/Pagination';
import { NotFound } from 'ui/NotFound/NotFound';

import { GetFlagsResponse, GetReportsResponse } from 'redux/reducers/moderation/types';
import { ReportsTableHeader } from '../ReportsTableHeader/ReportsTableHeader';
import { ReportsTableRow } from '../ReportsTableRow/ReportsTableRow';

type Props = {
  data: GetReportsResponse | null;
  flags: GetFlagsResponse | null;
  loading: boolean;

  page: number;
  perPage: number;
  onPageChange: (p: number) => void;
  onPerPageChange: (pp: number) => void;

  onAskConfirm: (id: string) => void;
};

export const ReportsTable: React.FC<Props> = ({
  data,
  flags,
  loading,
  page,
  perPage,
  onPageChange,
  onAskConfirm,
}) => {
  const rows = data?.data ?? [];
  const total = Number(data?.count ?? 0);

  return (
    <div className="reports-table">
      <ReportsTableHeader />

      {loading ? (
        <Loader />
      ) : rows.length ? (
        <div className="reports-table__body">
          {rows.map((item: any) => (
            <ReportsTableRow key={item?.report?.id ?? Math.random()} item={item} flags={flags} />
          ))}
        </div>
      ) : (
        <NotFound name="Data" />
      )}

      {total > perPage && (
        <div className="reports-table__pagination">
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onChange={onPageChange}
            siblingCount={1}
            boundaryCount={1}
          />
        </div>
      )}
    </div>
  );
};
